import {
	IScrollablePaneStyles,
	IStackStyles,
	IStackTokens,
	ScrollablePaneCompat as ScrollablePane,
	StackCompat as Stack,
} from 'components/FluentUICompat';
import {NotificationBar} from 'components';
import * as React from 'react';
import {Outlet} from 'react-router-dom';
import {Navigation} from './Navigation';
import {MessageBar} from './MessageBar';
import {SideNavigation} from './SideNavigation';
import {SideNavigationProvider} from './SideNavigation/SideNavigationProvider';

const containerStackTokens: IStackTokens = {childrenGap: 0};

const stackStyles: IStackStyles = {
	root: {
		marginTop: '0',
		overflow: 'hidden',
	},
};

const stackItemStyles: IStackStyles = {
	root: {
		height: '100%',
		position: 'relative',
	},
};

const getStackItemStyles = (heightMessageBar: number): IStackStyles =>
	heightMessageBar > 0
		? {
				root: {
					height: `calc(100% - ${heightMessageBar}px)`,
					position: 'relative',
				},
		  }
		: stackItemStyles;

const stackItemStylesMain: IStackStyles = {
	root: {
		width: 'calc(100% - 240px)',
	},
};

const scrollablePaneStylesRoot: IScrollablePaneStyles = {
	root: {
		background: 'rgb(237, 235, 233)',
	},
	stickyAbove: {},
	stickyBelow: {},
	stickyBelowItems: {},
	contentContainer: {},
};

export const DashboardLayout: React.FC = () => {
	const [heightMessageBar, setHeightMessageBar] = React.useState(0);

	return (
		<Stack tokens={containerStackTokens}>
			<Navigation />
			<Stack horizontal styles={stackStyles}>
				<SideNavigationProvider>
					<SideNavigation />
					<Stack styles={stackItemStylesMain} grow={1}>
						<MessageBar onHeightChange={setHeightMessageBar} />
						<NotificationBar timeout={1000} />
						<Stack.Item styles={getStackItemStyles(heightMessageBar)}>
							<ScrollablePane styles={scrollablePaneStylesRoot}>
								<Outlet />
							</ScrollablePane>
						</Stack.Item>
					</Stack>
				</SideNavigationProvider>
			</Stack>
		</Stack>
	);
};

export default DashboardLayout;
